import type { PtpCall } from '../types/vesselMaster';

const PORT_LABELS: Record<string, string> = { PTP: 'PTP', WESTPORTS: 'Westports', MMSW: 'MMSW' };

/** "PTP", "Westports" or "MMSW": the server's label, else read from `port`; PTP when nothing is known. */
export const callPortLabel = (call: Partial<Pick<PtpCall, 'port' | 'portLabel'>> | null | undefined): string => {
  if (call?.portLabel) return call.portLabel;
  return PORT_LABELS[call?.port ?? ''] ?? 'PTP';
};

/** "Westports B18", but "MMSW · Northport KCT": MMSW's terminal names are words, so they get a separator. */
export const portWithTerminal = (portLabel: string, terminal: string | null | undefined): string => {
  if (!terminal) return portLabel;
  return portLabel === 'MMSW' ? `${portLabel} · ${terminal}` : `${portLabel} ${terminal}`;
};

/** The call's port for a title: "MMSW · Northport KCT" for an MMSW call with a terminal, else the label. */
export const callPortTitle = (call: Partial<Pick<PtpCall, 'port' | 'portLabel' | 'terminal'>> | null | undefined): string =>
  portWithTerminal(callPortLabel(call), call?.terminal);

/** "636N", or "SCN 267DF4" for a call without a voyage (MMSW); empty when neither is known. */
export const callVoyageText = (call: Partial<Pick<PtpCall, 'voyage' | 'scn'>> | null | undefined): string => {
  if (call?.voyage) return call.voyage;
  return call?.scn ? `SCN ${call.scn}` : '';
};
